import React from 'react';
import PropTypes from 'prop-types';
import DataCard from 'components/common/card/DataCard';
import { PAYMENT_PROCESSOR, PAYMENT_STATUSES } from 'utils/constants';
import { formatReadMethod } from 'utils/formatReadMethod';
import { formatDate, formatPaymentTime } from 'utils/formatTimestamp';
import { formatCurrency } from 'utils/formatters/formatCurrency';
import { getPaymentTotalPaidText } from 'utils/formatters/getPaymentTotalPaidText';

export const PaymentDetails = ({ data, onHeaderAction }) => {
  const {
    id,
    createdAt,
    paymentProcessor,
    status,
    paymentToken,
    order,
    totalAmount,
    orderPaymentAmount,
    orderId,
    centsCustomerId,
    storeId,
    readMethod,
    paymentSource,
  } = data;

  const isStripeProcessor = paymentProcessor === PAYMENT_PROCESSOR.STRIPE;
  const totalPaidText = getPaymentTotalPaidText({
    totalAmount,
    orderPaymentAmount,
  });

  const details = [
    { label: 'Id', data: id },
    { label: 'Payment Date', data: formatDate(createdAt) },
    { label: 'Payment Time', data: formatPaymentTime(createdAt) },
    { label: 'Processor', data: paymentProcessor },
    { label: 'Status', data: status },
    {
      label: 'Token',
      data: paymentToken,
      type: 'external-link',
      href: `https://dashboard.stripe.com/payments/${paymentToken}`,
      isHidden: !isStripeProcessor,
    },
    { label: 'Timing', data: order?.paymentTiming },
    { label: 'Total Paid', data: totalPaidText },
    { label: 'Order Id', data: orderId },
    { label: 'Read Method', data: formatReadMethod(readMethod) },
    { label: 'Payment Source', data: paymentSource || '-' },
    {
      label: 'Customer Id',
      data: centsCustomerId,
      link: true,
      route: 'customers',
      id: centsCustomerId,
    },
    { label: 'Store Id', data: storeId, link: true, route: 'stores', id: storeId },
    { label: 'Order Code', data: order?.orderCode },
  ];

  const filteredDetails = details.filter(({ isHidden }) => !isHidden);

  return (
    <DataCard
      title="Payment Details"
      cardData={filteredDetails}
      headerActionTitle={null}
      headerAction={onHeaderAction}
    />
  );
};

PaymentDetails.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    createdAt: PropTypes.string,
    paymentProcessor: PropTypes.string,
    status: PropTypes.string,
    paymentToken: PropTypes.string,
    order: PropTypes.shape({ paymentTiming: PropTypes.string, orderCode: PropTypes.string }),
    totalAmount: PropTypes.number,
    orderId: PropTypes.number,
    centsCustomerId: PropTypes.number,
    storeId: PropTypes.number,
    readMethod: PropTypes.string,
    paymentSource: PropTypes.string,
  }).isRequired,
  onHeaderAction: PropTypes.func.isRequired,
};
